import React from 'react';
import PropTypes from 'prop-types';

import QuoteSOVButton from './quoteSOVButtons';
import { getPathVariables } from '../../misc';

import {
  DueMonthlyWrapper,
  DueNowWrapper,
  ButtonsWrapper,
  Button,
  Flex,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart,
  FractionalPart,
  Currency
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import OrderSummary from '../../iot/iotOrderFulfillmentDashboard/components/viewOrderDetails/components/summary';

const Desktop = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  isOrderSummary,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmit,
  onBack,
  onCancel,
  onPrintPDF,
  onSaveQuoteAsDocx,
  hidePricing,
  isQuoteApproved,
  isEligible,
  onOpenOrderDetail,
  channelName
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      DUE_NOW,
      BEFORE_TAXES,
      saveQuoteAsPDF,
      saveAndContinueLater,
      printPdf,
      proceesWithContracting
    },
    BUSINESS_APP_ORDERS: { saveQuote },
    formButtons: { continueButtonLabel, cancelButtonLabel, backButtonLabel }
  } = localizedStringsContext;

  const getFormattedPricing = pricing => {
    const newPricing = pricing.replace('$', '');
    const locale = getPathVariables(window.location.pathname)[0];
    return (
      <>
        <IntegralPart>
          {newPricing.split('.')[0]}
          <FractionalPart>
            {locale === 'fr-CA' ? ',' : '.'}
            {newPricing.split('.')[1]}
          </FractionalPart>
        </IntegralPart>
        <Currency style={{ order: locale === 'fr-CA' ? '3' : '-1' }}>
          $
        </Currency>
      </>
    );
  };
  return (
    <div id="footer-high">
      <>
        {!hidePricing && (
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(dueMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(dueNow)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
        )}

        {isOrderFulfillmentTeam ? (
          <QuoteSOVButton
            isFormTouched={isFormTouched}
            isFormValidated={isFormValidated}
            onDownloadClick={onDownloadClick}
            onProceedClick={onProceedClick}
            onValidateForm={onValidateForm}
          />
        ) : (
          <ButtonsWrapper>
            <Flex>
              {!isOrderSummary && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSaveAndExit(e)}
                    className="frg-button color-green"
                    disabled={!isFormTouched && !isQuoteApproved}
                  >
                    <span>{saveAndContinueLater}</span>
                  </button>
                </Button>
              )}
              {isOrderSummary && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onBack(e)}
                    className="frg-button color-green"
                  >
                    <span>{backButtonLabel}</span>
                  </button>
                </Button>
              )}
              {isOrderSummary && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSaveQuoteAsDocx(e)}
                    className="frg-button color-green"
                    disabled={!isEligible}
                  >
                    <span>{saveQuote}</span>
                  </button>
                </Button>
              )}
              {!OrderSummary && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSaveQuoteAsDocx(e)}
                    className="frg-button color-green"
                  >
                    <span>{saveQuote}</span>
                  </button>
                </Button>
              )}
              {!isOrderSummary && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSubmit(e)}
                    className="frg-button color-green"
                    disabled={!isEligible}
                  >
                    <span>{continueButtonLabel}</span>
                  </button>
                </Button>
              )}
              {isOrderSummary && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onCancel(e)}
                    className="frg-button color-green"
                  >
                    <span>{cancelButtonLabel}</span>
                  </button>
                </Button>
              )}
            </Flex>
          </ButtonsWrapper>
        )}
      </>
    </div>
  );
};

Desktop.propTypes = {
  isVBP: PropTypes.bool.isRequired,
  isOrderSummary: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onPrintPDF: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSaveQuoteAsPDF: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isQuoteApproved: PropTypes.bool.isRequired
};

export default Desktop;
